import styled from "styled-components";
import PageHeader from "components/common/ui/PageHeader";

const BottomSpacedPageHeader = styled(PageHeader)`
  padding-bottom: 1rem;
`;

export default BottomSpacedPageHeader;
